module.exports = __webpack_public_path__ + "static/media/info-selected.6aa5f549.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/info-selected.svg
// module id = 775
// module chunks = 0